import { Navigate, useLocation } from 'react-router';

import { GOALS_PATH } from '../api';

/**
 * The goals used to be a section of their own: `/goals`, `/goals/maps/<id>?panel=goal:<id>`. Bookmarks, notifications and
 * search results still hold those addresses, so they lead to the same place under the Tasks page (`/tasks/goals/...`), with
 * the query and the fragment (an open goal card, the list's filters, `?create=1`) kept.
 */
export function LegacyGoalsRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/goals/u, '').replace(/\/+$/u, '');
  return <Navigate to={{ pathname: `${GOALS_PATH}${rest}`, search, hash }} replace />;
}
